<div *ngIf="toastService.toast" class="toast-container position-absolute p-3" [ngClass]="toastService.toast.placement">
  <ngb-toast
    [class]="toastService.toast.classname"
    [autohide]="true"
    [delay]="toastService.toast.delay || 2000"
    (hidden)="toastService.clear()"
  >
    <ng-template [ngIf]="isTemplate(toastService.toast)" [ngIfElse]="text">
      <ng-template [ngTemplateOutlet]="toastService.toast.textOrTpl"></ng-template>
    </ng-template>

    <ng-template #text>
      <div class="d-flex gap-2">
        <i class="bi bi-check" *ngIf="toastService.toast.classname === 'bg-success'"></i>
        <i class="bi bi-x" *ngIf="toastService.toast.classname === 'bg-danger'"></i>
        <i class="bi bi-info-circle" *ngIf="toastService.toast.classname === 'bg-info'"></i>

        <span>{{ toastService.toast.textOrTpl }}</span>
      </div>
    </ng-template>
  </ngb-toast>
</div>
